// extracted by mini-css-extract-plugin
module.exports = {"emptyVersion":"StrategyTableVersion_emptyVersion__1-bls","versionContainer":"StrategyTableVersion_versionContainer__Sa0CV","version":"StrategyTableVersion_version__3Q65w"};